import React, { useRef, useEffect } from 'react';
import {
  Receipt,
  ArrowDownLeft,
  ArrowUpRight,
  Clock,
} from '@phosphor-icons/react';

const LogsContainer = ({ logs }) => {
  const scrollContainerRef = useRef(null);

  useEffect(() => {
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollTop =
        scrollContainerRef.current.scrollHeight;
    }
  }, [logs]);

  if (!logs || logs.length === 0) return null;

  return (
    <section className="logs-section">
      <div className="logs-card">
        <div className="logs-header">
          <div className="logs-title-wrap">
            <Receipt size={18} weight="bold" className="logs-icon" />
            <h2>Execution History</h2>
          </div>
          <span className="logs-count-badge mono">{logs.length} events</span>
        </div>

        <div className="logs-table-wrapper" ref={scrollContainerRef}>
          <table className="logs-table">
            <thead>
              <tr>
                <th>
                  <span className="th-with-icon">
                    <Clock size={12} weight="bold" />
                    Time
                  </span>
                </th>
                <th>Order</th>
                <th>Stock</th>
                <th>Step</th>
                <th className="text-right">Buy Price</th>
                <th className="text-right">Sell Price</th>
                <th className="text-right">Qty</th>
                <th className="text-right">Realized Profit</th>
                <th className="text-right">Yield</th>
              </tr>
            </thead>
            <tbody>
              {logs.map((log, index) => {
                const isBuy = log.order_type?.toLowerCase().includes('buy');
                const isSell = log.order_type?.toLowerCase().includes('sell');
                const isProfitable = (log.profit || 0) > 0;
                const isLoss = (log.profit || 0) < 0;

                return (
                  <tr key={index} className="log-row">
                    <td className="mono text-muted text-xs">
                      {new Date(log.timestamp).toLocaleDateString()}{' '}
                      {new Date(log.timestamp).toLocaleTimeString([], {
                        hour: '2-digit',
                        minute: '2-digit',
                        second: '2-digit',
                      })}
                    </td>
                    <td>
                      {isBuy ? (
                        <span className="order-chip buy">
                          <ArrowDownLeft size={11} weight="bold" />
                          BUY
                        </span>
                      ) : isSell ? (
                        <span className="order-chip sell">
                          <ArrowUpRight size={11} weight="bold" />
                          SELL
                        </span>
                      ) : (
                        <span className="order-chip neutral">
                          {log.order_type}
                        </span>
                      )}
                    </td>
                    <td className="font-semibold">{log.stock}</td>
                    <td>
                      <span className="step-num-pill mono">
                        #{log.investment_step_idx}
                      </span>
                    </td>
                    <td className="mono text-right">
                      {log.buy_price ? log.buy_price.toLocaleString() : '—'}
                    </td>
                    <td className="mono text-right">
                      {log.sell_price ? log.sell_price.toLocaleString() : '—'}
                    </td>
                    <td className="mono text-right">{log.count || '—'}</td>
                    <td
                      className={`mono text-right font-medium ${
                        isProfitable
                          ? 'text-success'
                          : isLoss
                            ? 'text-danger'
                            : 'text-muted'
                      }`}
                    >
                      {log.profit != null
                        ? `${log.profit > 0 ? '+' : ''}${log.profit.toLocaleString()}`
                        : '—'}
                    </td>
                    <td
                      className={`mono text-right font-medium ${
                        isProfitable
                          ? 'text-success'
                          : isLoss
                            ? 'text-danger'
                            : 'text-muted'
                      }`}
                    >
                      {log.profit_percent != null
                        ? `${log.profit_percent > 0 ? '+' : ''}${log.profit_percent.toFixed(2)}%`
                        : '—'}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
};

export default LogsContainer;
